export const getCurrentCities = ({ city = {} } = {}) => city;

export default getCurrentCities;
